import { render, staticRenderFns } from "./jieguo.vue?vue&type=template&id=08b0f8ac&scoped=true"
import script from "./jieguo.vue?vue&type=script&lang=js"
export * from "./jieguo.vue?vue&type=script&lang=js"
import style0 from "./jieguo.vue?vue&type=style&index=0&id=08b0f8ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b0f8ac",
  null
  
)

export default component.exports